module.exports = __webpack_public_path__ + "img/technologyModel.4b8176d5.png";